import { render, staticRenderFns } from "./aside.component.vue?vue&type=template&id=3d5503fd&scoped=true"
import script from "./aside.component.vue?vue&type=script&lang=ts"
export * from "./aside.component.vue?vue&type=script&lang=ts"
import style0 from "./aside.component.vue?vue&type=style&index=0&id=3d5503fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5503fd",
  null
  
)

export default component.exports